module.exports = __webpack_public_path__ + "img/28_23.f6d97876.png";